import React, { Component } from 'react'
import './hero.scss'

class Hero extends Component {
  render() {
    return (
      <div styleName="hero">
        <div styleName="cover">
          <div styleName="content">
            <h1>テレワーク応援特集</h1>
            <br/>
            <p>無人チェックインで安心のWi-Fi、家具付き宿泊・民泊施設</p>
          </div>
        </div>
        <div styleName="description content">
          <h2><span>今だからこそ</span><span>「場所」が必要な人のために</span></h2>
          <p>新型コロナウイルスの感染拡大を防止する有効な対策の一つとしてテレワークの積極的な活用が推進されています。<br/>
          しかし、自宅に仕事専用スペースが無かったり、Wi-Fi環境が整っていない等、なかなか集中できる環境が作れずにお困りの方もいるのではないでしょうか？</p>
          <p>そのような方々のために、人との接触がなく安心してご利用いただける無人チェックイン対応で<br/>
          テレワークには必須となるWi-Fiやその他家具付きの宿泊・民泊施設を集めました。</p>
          <p>ぜひ、自宅の近くまたは通勤を余儀なくされている方は勤務先の近くなどで探してみてください。</p>
        </div>
        <div styleName="features content">
          <div styleName="feature-item">
            <img src="/assets/image/features/telework/feature-1.jpg" alt="無人チェックインで安心" />
            <h3>無人チェックインで安心</h3>
            <p>フロント等での鍵の受け渡しなどはなく、チェックイン/チェックアウト端末や電子錠を用いることで誰とも合わずに宿泊することが可能。</p>
          </div>
          <div styleName="feature-item">
            <img src="/assets/image/features/telework/feature-2.jpg" alt="ひとりでも家族でも" />
            <h3>ひとりでも家族でも</h3>
            <p>ワンルームタイプのお部屋から一戸建てまで、様々なタイプ、広さの宿泊・民泊施設から用途や状況に応じて滞在先をお選びいただけます。</p>
          </div>
          <div styleName="feature-item">
            <img src="/assets/image/features/telework/feature-3.jpg" alt="長期滞在にも対応" />
            <h3>長期滞在にも対応</h3>
            <p>家具付きの他、キッチンや冷蔵庫、洗濯機完備で滞在が長期になっても便利にご利用いただけます。長期滞在割引のある施設もあります。</p>
          </div>
        </div>
        <div styleName="infection-prevention">
          <div styleName="content">
            <h2>感染しない、させないために</h2>
            <div styleName="images">
              <div styleName="image sanitizer">
                <div styleName="tag">消毒液</div>
              </div>
              <div styleName="image sanitizing">
                <div styleName="tag">清掃時に消毒実施</div>
              </div>
              <div styleName="image linen">
                <div styleName="tag">清掃毎にリネン類交換</div>
              </div>
            </div>
            <p>ひとりでも多くの「場所」を必要とする人の助けとなるように、また、安心して宿泊していただけるように多くの宿泊・民泊施設がコロナ感染対策に取り組んでいます。</p>
          </div>
        </div>
      </div>
    )
  }
}

export default Hero
